import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CartProvider } from './components/produit/CartContext';
import axios from "axios";
import "./App.css";
import Connexion from "./components/login/connexion";
import ActivationPage from "./components/login/activation";
import Dashboard from "./components/dashboard/dashboard";
import Admin from "./components/administration/admin";
import Liste_utilisateur from "./components/administration/utilisateurs/liste_utilisateur";
import Profil_utilisateur from "./components/dashboard/profil";
import Liste_produit from "./components/administration/produit/liste_produit";
import Ajouter_produit from "./components/administration/produit/ajouter_produit";
import MotDePassePage from "./components/login/mot_de_passe";
import Modifier_produit from "./components/administration/produit/modifier_produit";
import Liste_groupe from "./components/administration/groupe/groupe";
import Ajouter_groupe from "./components/administration/groupe/ajouter_groupe";
import Modifier_groupe from "./components/administration/groupe/modifier_groupe";
import Ajouter_acces from "./components/administration/groupe/ajouter_acces";
import Ajouter_utilisateur_groupe from "./components/administration/groupe/ajouter_utilisateur_groupe";
import LoadingSpinner from "./components/login/loading";
import Configurer_groupe from "./components/administration/groupe/configurer_groupe";
import Panier from "./components/produit/panier";
import Liste_categorie from "./components/administration/categorie/liste_categorie";
import PaiementProduit from "./components/produit/paiementproduit";
import Detail_produit from "./components/produit/detail_produit";
import PaymentSuccess from "./components/produit/PaymentSuccess";
import Liste_achats from "./components/produit/liste_achats";
import Mes_produits from "./components/gestionnaire/mes_produits";
import Ventes from "./components/gestionnaire/vente";
import Transaction from "./components/administration/transaction";
import Mes_achats from "./components/gestionnaire/mes_achats";
import Accueil from "./components/produit/accueil";
import Boutique from "./components/administration/boutique";
import Remboursement from "./components/remboursement/remboursements";
import Liste_remboursement from "./components/remboursement/liste_remboursement_client";
import InfoAchat from "./components/produit/info_achat";

function App() {
  const user_id = localStorage.getItem("IDDDD");
  const groupe = localStorage.getItem("groupe");
  const acces = localStorage.getItem("accesGroupe");
  const [accesGroupe, setAccesGroupe] = useState([]);
  const [loading, setLoading] = useState(true); // Un état pour savoir si la vérification est terminée
  // const [utilisateurId, setUtilisateurId] = useState();
  // const [groupeId, setGroupeId] = useState();

  // useEffect(() => {
  //   if (!user_id) {
  //     window.location.reload();
  //     const user_id = localStorage.getItem('IDDDD');
  //     const groupe = localStorage.getItem('groupe');
  //     setUtilisateurId(user_id)
  //     setGroupeId(groupe)
  //   }
  // }, []);

  // Fetch user access rights une seule fois au chargement
  const fetchAccessRights = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`
      );
      const data = response.data;
      // setAccesGroupe(data.acces[0].acces); // Mettre à jour les accès

      let cleanedAccessArray = [];
      if (Array.isArray(data.acces)) {
        cleanedAccessArray = data.acces
          .map((item) =>
            item.acces
              ? item.acces
                  .replace(/[\[\]']/g, "")
                  .trim()
                  .split(",")
                  .map((access) => access.trim())
              : []
          )
          .flat();

        setAccesGroupe(cleanedAccessArray);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des accès:", error);
    } finally {
      setLoading(false); // Fin de la vérification
    }
  };

  useEffect(() => {
    fetchAccessRights();
  }, [user_id]);

  if (loading) {
    // Affiche un écran de chargement pendant la vérification
    return <LoadingSpinner />;
  }

  const userHasAccess = (accessKey) => {
    if (!acces) {
      return false;
    }

    // Vérifie si l'utilisateur a l'accès spécifié
    return accesGroupe && acces.includes(accessKey);
  };

  return (
    <CartProvider>
      <Router>
        <Routes>
          <Route path="/papachigan" element={<Accueil />} />
          <Route path="/" element={<Connexion />} />
          <Route path="/activation-page" element={<ActivationPage />} />
          <Route path="/mot-de-passe" element={<MotDePassePage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/Profil-utilisateur" element={<Profil_utilisateur />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/boutique" element={<Boutique />} />

          <Route path="/mes-produits" element={<Mes_produits />} />
          <Route path="/mes-achats" element={<Mes_achats />} />
          <Route path="/liste-remboursements" element={<Liste_remboursement />} />

          <Route path="/Liste-utilisateur" element={<Liste_utilisateur />} />
          <Route path="/Liste-produit" element={<Liste_produit />} />
          <Route path="/Liste-categorie" element={<Liste_categorie />} />
          <Route path="/Ajouter-produit" element={<Ajouter_produit />} />
          <Route path="/Modifier-produit" element={<Modifier_produit />} />
          <Route path="/Liste-groupe" element={<Liste_groupe />} />
          <Route path="/Ajouter-groupe" element={<Ajouter_groupe />} />
          <Route path="/Modifier-groupe" element={<Modifier_groupe />} />
          <Route path="/Configurer-groupe" element={<Configurer_groupe />} />
          <Route path="/ajouter-utilisateur-groupe" element={<Ajouter_utilisateur_groupe />} />
          <Route path="/Transaction" element={<Transaction />} />


          <Route path="/Ajouter-acces/:groupe_id" element={<Ajouter_acces />} />
          <Route path="/Detail-produit/:slug?" element={<Detail_produit />} />
          <Route path="/info-achat/:id" element={<InfoAchat />} />
          <Route path="/Panier" element={<Panier />} />
          <Route path="/paiement-reussi" element={<PaymentSuccess />} />
          <Route path="/liste-achats" element={<Liste_achats />} />
          <Route path="/suivi-vente" element={<Ventes />} />
          <Route path="/remboursements" element={<Remboursement />} />
          

          {/* <Route path="/Maintenance" element={<MaintenancePage />} /> */}
        </Routes>
      </Router>
    </CartProvider>
  );
}
export default App;
